import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  input,
  untracked,
  viewChild,
} from '@angular/core';
import { DotLottie } from '@lottiefiles/dotlottie-web';

@Component({
  selector: 'cgw-animation-player',
  standalone: true,
  templateUrl: './animation-player.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnimationPlayerComponent {
  //#region I/O
  public readonly src = input.required<string>();
  public readonly autoplay = input<boolean>(true);
  public readonly loop = input<boolean>(false);
  //#endregion

  private readonly _playerCanvas = viewChild<ElementRef<HTMLCanvasElement>>('animationCanvas');
  private _player: DotLottie | null = null;

  constructor() {
    this.initPlayer();
  }

  private initPlayer(): void {
    effect(() => {
      const canvas = this._playerCanvas()?.nativeElement;
      const src = this.src();

      if (canvas == null || !src) return;
      if (this._player != null) this._player.destroy();

      untracked(() => {
        this._player = new DotLottie({
          autoplay: this.autoplay(),
          loop: this.loop(),
          src,
          canvas,
        });
      });
    });
  }
}
